'use client';

import { useEffect } from 'react';

export default function NotFound() {
  useEffect(() => {
    // Immediately redirect to homepage without showing any content
    if (typeof window !== 'undefined') {
      window.location.replace('/');
    }
  }, []);

  // Return null to prevent any rendering
  return null;
}

